// import { takeEvery,put,call } from "redux-saga/effects";
// import{
//     NPAPOPUP
// } from "./actiontype"
// import{
//     NpaPopupSuccess,
//     NpaPopupFail,
// } from "./action"
// import{
//     NpaPopup,
// } from "../../_helper/services/npaa"

// function * getNpa({payload:{employeeID,HrControl}}){
//     try{
//         const response= yield call(NpaPopup,{employeeID,HrControl});
//         yield put (NpaPopupSuccess(response));
//         console.log("responce",response)
//     } catch (error){
//     yield put ( NpaPopupFail(error.message))
// }
// }
// function * CartSaga(){
//     yield takeEvery(NPAPOPUP,getNpa)
// }
// export default CartSaga
import { put, takeLatest, takeEvery, call } from "redux-saga/effects";
import { NPAPOPUP } from "./actiontype";
import {NpaDetailsSuccess,NpaDetailsFail} from "./action"
import { NpaPop } from "../../_helper/services/npaa";

function * getNpa({payload:{employeeID, HrControl,NatureActionCode}}){
    // debugger;
    try{
        const responce = yield call (NpaPop,{employeeID,HrControl,NatureActionCode});
        yield put (NpaDetailsSuccess(responce));
        console.log("responce", responce)
    } catch (error){
        yield put (NpaDetailsFail(error.message))
    }
}
function * CartSaga(){
    yield takeEvery(NPAPOPUP,getNpa)
}
export default CartSaga